<template>
	<div class="ml-4 mr-4 mt-4 mb-4">
		<printHeader></printHeader>

		

		<h4 class="mt-2">Request Parts Quotation</h4>
		<hr>

		<div class="row mb-2">
			<div class="col-md-2">
				Nomor Work Order
			</div>
			<div class="col-md-4">
				{{woDetail.work_order_id}}
			</div>
			<div class="col-md-2">
				Tanggal Masuk
			</div>
			<div class="col-md-4">
				{{woDetail.tanggal_masuk}}
			</div>
		</div>
		<div class="row mb-2">
			<div class="col-md-2">
				Nomor Rangka
			</div>
			<div class="col-md-4">
				{{woDetail.nomor_rangka}}
			</div>
			<div class="col-md-2">
				Nomor Mesin
			</div>
			<div class="col-md-4">
				{{woDetail.nomor_mesin}}
			</div>
		</div>
		<div class="row mb-2">
			<div class="col-md-2">
				Merek Mobil
			</div>
			<div class="col-md-4">
				{{woDetail.merek}}
			</div>
			<div class="col-md-2">
				Tipe Mobil
			</div>
			<div class="col-md-4">
				{{woDetail.tipe}}
			</div>
		</div>
		<div class="row mb-2">
			<div class="col-md-2">
				Tahun Mobil
			</div>
			<div class="col-md-4">
				{{woDetail.year}}
			</div>
			<!-- <div class="col-md-2">
				Tipe Mobil
			</div>
			<div class="col-md-4">
				{{woDetail.tipe}}
			</div> -->
		</div>

		<h5 class="mt-5">Nama Supplier : &nbsp;&nbsp;______________________________</h5>


		<table class="table table-bordered text-center mt-5">
			<thead>
				<th>No.</th>
				<th>Nama</th>
				
				<th>Jumlah</th>
				<th>Nomor Part</th>
				<th>Waktu Inden</th>
				<th>Harga Pricelist</th>
				<th>Diskon</th>
				<th>PPN</th>
				<th>Harga Net</th>
			</thead>
			<tbody v-for="(estimation , index) in sparepartEstimations" :key="index">
				<tr>
					<td>{{index + 1}}</td>
					<td>{{estimation.sparepart_name}}</td>
					<td>{{estimation.quantity}}</td>
					<td></td>
					<td></td>
					<td></td>
					<td></td>
					<td>Y  &nbsp;/ &nbsp;N</td>
					<td></td>
				</tr>
				<tr class="text-left">
					<td colspan="9">Deskripsi Sparepart : {{estimation.part_number}}</td>
				</tr>
			</tbody>
		</table>


	</div>
</template>

<script>
import printHeader from '@/components/print/print_header.vue'

export default {
	props : ['woDetail' , 'sparepartEstimations'],
	components :{
		printHeader
	}
}
</script>